import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateHelperService } from '../../services/TranslateService';
import { map } from 'rxjs';
import { AppState } from '../../services/app.service';
import { UserService } from '../../dataServices/userService';
import { Vehicle } from './verification-tractors.model';
import { PdfReportService, PdfResponse } from '../../services/pdfReport.service';
import { LinkService } from '../../services/link.service';
import { LanguageService } from '../../services/language.service';
import { User } from '../../models/user';
import { ContactInfo, SubdomainConfigService } from 'src/app/services/subdomainConfig.service';

@Component({
    selector: 'self-ins-verification-tractors',
    templateUrl: './verification-tractors-page.component.html',
    styleUrls: ['./verification-tractors-page.component.scss'],
    standalone: false
})
export class VerificationTractorsPageComponent implements AfterViewInit {
    @ViewChild(MatSort) public sort: MatSort | undefined;
    public user!: User;
    public gridFilterValue = '';
    public displayedColumns = ['vin', 'year', 'make', 'equipmentId', 'fuelType', 'pickupDate', 'returnDate'];
    public tractors = new MatTableDataSource<Vehicle>([]);
    public allVehiclesPdf: PdfResponse | null = null;
    public qnum: number = 0;
    public qsuffix: string = '';
    public currentLocale: string = 'en-GB';
    public dateFormat: string = 'dd/MM/y';
    public email: string = '';
    public supportEmail: string = '';
    public constructor(private router: Router,
                       private activeRouter: ActivatedRoute,
                       private appState: AppState,
                       private userService: UserService,
                       private linkService: LinkService,
                       private languageService: LanguageService,
                       public _translateService: TranslateHelperService,
                       private subdomainConfigService: SubdomainConfigService) {
        this.user = this.appState.user.getValue();
        this.currentLocale = this.languageService.getCurrentLocale();
        this.dateFormat = this.languageService.getShortDateFormat();
        const contactInfo: ContactInfo = this.subdomainConfigService.getContactInfo();
        this.email = contactInfo.email;
        this.supportEmail = contactInfo.supportEmail;

        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
        
            this.userService.getVehicles(this.qnum, this.qsuffix)
                .subscribe({
                    next: (x) => {
                        this.tractors.data = x.sort((a, b) => {
                            return Number(new Date(b.pickupDate)) - Number(new Date(a.pickupDate))
                        });
                    }
                });
        });
    }

    ngAfterViewInit() {
        this.tractors.sort = this.sort || null;
    }

    applyFilter() {
        this.tractors.filter = this.gridFilterValue.trim().toLowerCase();
    }

    public clearSearch() {
        this.gridFilterValue = '';
        this.applyFilter();
    }

    public downloadFile(data: PdfResponse) {
        this.linkService.openBlob(
            data.content as ArrayBuffer, { description: data.name });
    }

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}
